import {doc} from '../docs.js';
import {extractCode} from './extract.js';
import {lazy} from './lazy.js';
import {gl} from './struct.js';
import {isNumber} from "utils/IsNumber.js"

doc(
    "gl.abs",
    {
        "x": ""
    },
    "Creates GLSL expression calculating absolute value of inlet",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1
    });

const gl_abs = (object) => {
    object.needsHotReload = true;
    return lazy(
        (x) => {
            let codes = extractCode(x);
            object.flash();
            return "abs(" + float(codes[0]) + ")";
        });
};

doc(
    "gl.mix",
    {
        "a": "",
        "b": "",
        "mix amt": "",
    },
    "Creates GLSL expression calculating mix interpolation between inlets",
    () => 1,
    {
        isHot: true,
        tags: "GLSL",
        inlets: 3
    });

const gl_mix = (object, b, c) => {
    object.needsHotReload = true;
    return lazy(
        (x) => {
            let codes = extractCode(x, b, c);
            object.flash();
            return `mix(${float(codes[0])}, ${float(codes[1])}, ${float(codes[2])})`;
        }, b, c);
};

doc(
    "gl.rainbow",
    {
        "x": ""
    },
    "Creates GLSL expression calculating rainbow value of inlet",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1
    });

const gl_rainbow = (object) => {
    object.needsHotReload = true;
    return lazy(
        (x) => {
            let codes = extractCode(x);
            object.flash();
            return "rainbow(" + float(codes[0]) + ")";
        });
};

doc(
    "gl.exp",
    {
        "x": ""
    },
    "Creates GLSL expression calculating absolute value of inlet",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1
    });

const gl_exp = (object) => {
    object.needsHotReload = true;
    return lazy(
        (x) => {
            let codes = extractCode(x);
            object.flash();
            return "exp(" + float(codes[0]) + ")";
        });
};

doc(
    "gl.min",
    {
    },
    "Creates GLSL expression calculating min of inlets",
    () => 1,
    {
        tags: "GLSL",
        isHot: true,
        inlets: 2
    });

const gl_min = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
            object.flash();
        return `min(${codes[0]}, ${codes[1]})`;
    }, b);
};

doc(
    "gl.max",
    {
    },
    "Creates GLSL expression calculating max of inlets",
    () => 1,
    {
        isHot: true,
        inlets: 2
    });

const gl_max = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `max(${float(codes[0])}, ${float(codes[1])})`;
    }, b);
};

doc(
    "gl.mod",
    {
    },
    "Creates a GLSL expression calculating the modulo of inlets",
    () => 1,
    {
        tags: "GLSL",
        isHot: true,
        inlets: 2
    });

const gl_mod = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `mod(${float(codes[0])}, ${float(codes[1])})`;
    }, b);
};

doc(
    "gl.clamp",
    {
        "a": "",
        "b": "",
    },
    "Creates GLSL expression clamping left-inlet number between 2nd and 3rd inlet",
    () => 1,
    {
        isHot: true,
        inlets: 3,
        tags: "GLSL",
    });

const gl_clamp = (object, b,c) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b,c);
        object.flash();
        return `clamp(${float(codes[0])}, ${float(codes[1])}, ${float(codes[2])})`;
    }, b, c);
};


export const utils = {
    "gl.abs": gl_abs,
    "gl.min": gl_min,
    "gl.max": gl_max,
    "gl.mod": gl_mod,
    "gl.clamp": gl_clamp,
    "gl.exp": gl_exp,
    "gl.rainbow": gl_rainbow,
    "gl.mix": gl_mix,
};

// extracts the code and uniforms from a set of inlet arguments
// can then pass these to gl() to create a new gl object to be passed along
export const extract = (...args) => {
    let uniforms = {};
    let closure  = {};
    let functions = {};
    let codes = [];

    for (let arg of args) {
        if (typeof arg === "function") {
            arg = arg();
        }
        arg = arg === undefined ? {} : arg;
        let _uniforms = arg.uniforms || {};
        uniforms = {
            ... uniforms,
            ... _uniforms
        };

        let _functions = arg.functions || {};
        functions = {
            ... functions,
            ... _functions
        };

        let _closure  = arg.closure|| {};
        closure = {
            ... closure,
            ... _closure
        };
 
        codes.push(arg.code || arg || "0.0");
    }

    return {codes, uniforms, functions, closure};
};

export const float = (x) => {
    if (typeof x === "object") {
        return "1.0";
    }
    if (x === "bang" || x === undefined) {
        return "1.0";
    }
    if (x.toFixed) {
        return x.toFixed(3);
    } else {
        return x;
    }
};
